import '../../../../assets/css/screens/serviceprovider/dashboard/subscription/WorkerSubHistory.css';

import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Zap, TrendingUp, DollarSign, Calendar,
  CheckCircle, Clock, XCircle, ChevronRight, Bell,
  Shield, RefreshCw
} from 'lucide-react';
import WorkerSubscriptionHistorySkeleton from "../../../../components/skeltonloading/WorkerSubscriptionHistorySkeleton"
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';

const pad = (n) => String(n).padStart(2, '0');

const STATUS_CFG = {
  active:  { label: 'Active',  color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  expired: { label: 'Expired', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
};

const HISTORY_TABS = ['All', 'Expired'];

const useCountdown = (endDate) => {
  const calculateTime = () => {
    if (!endDate) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    const difference = new Date(endDate) - new Date();
    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days:    Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours:   Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [time, setTime] = useState(calculateTime());

  useEffect(() => {
    const timer = setInterval(() => setTime(calculateTime()), 1000);
    return () => clearInterval(timer);
  }, [endDate]);

  return time;
};

const SubscriptionHistory = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const [historyTab,   setHistoryTab]   = useState('All');
  const [subscription, setSubscription] = useState(null);
  const [history,      setHistory]      = useState([]);
const [loading,setLoading]=useState(true);
  const getCurrentSubscription = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/current/subscription`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      if (response.data.success) 
        console.log(response.data.subscription);
console.log(response.data.subscription.whsubscription.features);
console.log(typeof response.data.subscription.whsubscription.features);
console.log(subscription?.whsubscription?.features);
console.log(subscription.whsubscription.features);
console.log(subscription.whsubscription.features[0]);
        console.log(response.data.subscription.whsubscription);
        setSubscription(response.data.subscription);
    } catch (error) {
      console.log(error);
    }
     finally {
      setLoading(false);
    }
  };

  const getSubscriptionHistory = async () => {
    try {
      const response = await axios.get(`${baseUrl}/subscription/history`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      if (response.data.success) setHistory(response.data.history);
    } catch (error) {
      console.log(error);
    }
  };

  const getProgress = () => {
    if (!subscription?.start_date || !subscription?.end_date) return 0;
    const start = new Date(subscription.start_date).getTime();
    const end   = new Date(subscription.end_date).getTime();
    const now   = new Date().getTime();
    const totalDuration = end - start;
    const elapsed = now - start;
    if (elapsed <= 0) return 0;
    if (elapsed >= totalDuration) return 100;
    return Math.round((elapsed / totalDuration) * 100);
  };

  const usedPercent = getProgress();
  const time = useCountdown(subscription?.end_date);

  const filteredHistory =
    historyTab === 'All'
      ? history
      : history.filter(item => item.status === 'expired');

  useEffect(() => {
    getCurrentSubscription();
    getSubscriptionHistory();
  }, []);
if(loading){

    return <WorkerSubscriptionHistorySkeleton />;

}
  return (
    <>
      <WorkerNavbar />
      <div className="wsub-page">

        {/* MOBILE HEADER */}
        <div className="wsub-mob-header d-md-none">
          <button className="wsub-back-btn" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <div>
            <h4 className="wsub-mob-title">My Subscriptions</h4>
            <p className="wsub-mob-sub">Manage your membership plans</p>
          </div>
        </div>

        <div className="wsub-container">

          {/* DESKTOP HEADER */}
          <div className="wsub-desk-header">
            <div>
              <h2 className="wsub-desk-title">Subscription History</h2>
              <p className="wsub-desk-sub">Your complete record of plans and renewals</p>
            </div>
          </div>

          {/* CURRENT PLAN CARD */}
          <div className="wsub-current-card">

            <div className="wsub-current-card__top">
              <div className="wsub-current-card__left">
                <div className="wsub-current-card__icon">
                  <Zap size={20} />
                </div>
                <div>
                  <div className="wsub-current-card__name-row">
                    <span className="wsub-live-badge">
                      <span className="wsub-live-dot" />
                      {subscription?.status === 'expired' ? 'Expired' : 'Live'}
                    </span>
                  </div>
                  <p className="wsub-current-renews">
                    Renews on {subscription?.end_date}
                  </p>
                </div>
              </div>
              <div className="wsub-current-card__price-wrap">
                <span className="wsub-current-price">${subscription?.whsubscription?.price}</span>
                <span className="wsub-current-period">/ {subscription?.whsubscription?.duration}</span>
              </div>
            </div>

            {/* Countdown */}
            <div className="wsub-countdown-label">Expires in</div>
            <div className="wsub-countdown">
              {[
                { val: pad(time.days),    label: 'DAYS'    },
                { val: pad(time.hours),   label: 'HOURS'   },
                { val: pad(time.minutes), label: 'MINUTES' },
                { val: pad(time.seconds), label: 'SECONDS' },
              ].map((item, i) => (
                <div key={i} className="wsub-countdown-unit">
                  <span className="wsub-countdown-val">{item.val}</span>
                  <span className="wsub-countdown-lbl">{item.label}</span>
                </div>
              ))}
            </div>

            {/* Progress bar */}
            <div className="wsub-progress-wrap">
              <span className="wsub-progress-start">{subscription?.start_date}</span>
              <div className="wsub-progress-bar">
                <div className="wsub-progress-fill" style={{ width: `${usedPercent}%` }} />
              </div>
              <span className="wsub-progress-end">{subscription?.end_date}</span>
            </div>
            <div className="wsub-progress-pct">{usedPercent}% used</div>

            {/* Features */}
            <div className="wsub-current-features">
              {(subscription?.whsubscription?.features || '')
                .split(',')
                .map((feature, index) => (
                  <span key={index} className="wsub-feature-item">
                    <CheckCircle size={13} className="wsub-feature-check" />
                    {feature.trim()}
                  </span>
                ))}
            </div>

            {/* Actions */}
            <div className="wsub-current-actions">
              <button
                className="wsub-upgrade-btn"
                onClick={() => navigate('/workersubscription')}
              >
                <RefreshCw size={14} /> Upgrade Plan
              </button>
            </div>

          </div>

          {/* PAST RECORDS */}
          <div className="wsub-history-section">
            <div className="wsub-history-header">
              <h5 className="wsub-history-title">
                Past Records
                <span className="wsub-history-title-sub d-none d-md-inline"> — view full record →</span>
              </h5>
              <div className="wsub-history-tabs">
                {HISTORY_TABS.map(t => (
                  <button
                    key={t}
                    className={`wsub-history-tab${historyTab === t ? ' wsub-history-tab--active' : ''}`}
                    onClick={() => setHistoryTab(t)}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>

            <div className="wsub-history-list">
              {filteredHistory.length === 0 ? (
                <div className="wsub-history-empty">No records found.</div>
              ) : filteredHistory.map((h) => {
                const st = STATUS_CFG[h.status] || STATUS_CFG.expired;
                return (
                  <div key={h.id} className="wsub-history-item">
                    <div className="wsub-history-item__left">
                      <div className="wsub-history-item__icon">
                        <Zap size={16} />
                      </div>
                      <div className="wsub-history-item__info">
                        <div className="wsub-history-item__name-row">
                          <span className="wsub-history-item__name">
                            {h.whsubscription?.planName}
                          </span>
                          <span
                            className="wsub-history-item__status"
                            style={{ color: st.color, background: st.bg }}
                          >
                            {h.status === 'active'
                              ? <CheckCircle size={10} />
                              : <Clock size={10} />
                            }
                            {st.label}
                          </span>
                        </div>
                        <span className="wsub-history-item__dates">
                          {h.start_date} — {h.end_date}
                        </span>
                        <span className="wsub-history-item__meta">{h.user}</span>
                      </div>
                    </div>
                    <div className="wsub-history-item__right">
                      <span className="wsub-history-item__price">${h.whsubscription?.price}</span>
                      <span className="wsub-history-item__period">{h.whsubscription?.duration}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Footer */}
          <p className="wsub-footer-note">
            <Shield size={13} /> Encrypted records · Cancel anytime from settings
          </p>

        </div>
      </div>
    </>
  );
};

export default SubscriptionHistory;